import { CountriesList } from '@/shared/constants/countries-list';
import { QuestionType } from '@/shared/lib/sj-orm/models/form/question.dto';
import { omit } from '@/shared/utils/omit';

import { PersonalIdentifierDetails } from '../../sj-orm';
import { TDtoWrapper } from '../form-wrapper.types';

import {
  commonDetailsFields,
  commonGeneralFields,
  commonLegalizedCopiesFields,
  LegalizedCopiesPartType,
  PersonalIdentifierDetailsFormType,
  PersonalIdentifierGeneralFormType,
} from './commonFields';

export type BirthCertificateGeneralDto = Omit<
  PersonalIdentifierDetails,
  'createdAt' | 'updatedAt'
> & {
  fullBirthName?: string;
};

type BirthCertificateGeneralHelp = {
  fullBirthName: QuestionType.TEXT;
};

export type BirthCertificateGeneralFormType = PersonalIdentifierGeneralFormType &
  TDtoWrapper<BirthCertificateGeneralDto, BirthCertificateGeneralHelp>;

export const BirthCertificateGeneralSection: BirthCertificateGeneralFormType = {
  ...commonGeneralFields,
  fullBirthName: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:birthCertificate.inputs.fullBirthName.label',
    value: '',
    capitalized: true,
    order: 7,
  },
};

export type BirthCertificateDetailsDto = Omit<
  PersonalIdentifierDetails,
  'createdAt' | 'updatedAt'
> & {
  registrationNumber?: string;
  parent1?: string;
  parent2?: string;
  nationalityAtBirth?: string;
};

type BirthCertificateDetailsHelp = {
  registrationNumber?: QuestionType.TEXT;
  parent1?: QuestionType.TEXT;
  parent2?: QuestionType.TEXT;
  nationalityAtBirth?: QuestionType.SELECT_FROM_LIST;
};

export type BirthCertificateDetailsFormType = Omit<
  PersonalIdentifierDetailsFormType,
  'basisForIssuingId' | 'issuerCode' | 'other'
> &
  TDtoWrapper<BirthCertificateDetailsDto, BirthCertificateDetailsHelp>;

export const BirthCertificateDetailsSection: BirthCertificateDetailsFormType = {
  registrationNumber: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:education.inputs.registrationNumber.label',
    value: '',
    capitalized: true,
    order: 3,
  },
  parent1: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:birthCertificate.inputs.parent1.label',
    value: '',
    capitalized: true,
    order: 7,
  },
  parent2: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:birthCertificate.inputs.parent2.label',
    value: '',
    capitalized: true,
    order: 7,
  },
  nationalityAtBirth: {
    type: QuestionType.SELECT_FROM_LIST,
    label: 'forms_personal_ids:birthCertificate.inputs.nationalityAtBirth.label',
    items: CountriesList,
    withSearch: true,
    value: '',
    capitalized: true,
    order: 7,
  },
  ...omit(commonDetailsFields, 'basisForIssuingId', 'issuerCode', 'endDate'),
};

export const BirthCertificateLegalizedCopiesSection: LegalizedCopiesPartType = {
  ...commonLegalizedCopiesFields,
};

export const BirthCertificateFormSections = [
  BirthCertificateGeneralSection,
  BirthCertificateDetailsSection,
  BirthCertificateLegalizedCopiesSection,
];
